'use client';

import { useTranslations } from 'next-intl';

import type { JobChangedCountStep } from '@/modules/authentication/view-model';

import { JobChangeCountEnum } from '@packages/contracts';
import { Form } from '@packages/hook-form-wrapper';

export const JobChangedCount = () => {
	const t = useTranslations('authentication.registration.form.jobChangeCount');

	const options = JobChangeCountEnum.options.map(value => ({
		label: t('enum', { jobChangeCount: value }),
		value,
	}));

	return (
		<Form.RadioGroup<JobChangedCountStep>
			gap={8}
			name="jobChangeCount"
			options={options}
		/>
	);
};
